import { Card, Group, Stack, Text, ThemeIcon } from '@mantine/core'
import { IconTrendingUp, IconTrendingDown, IconMinus } from '@tabler/icons-react'
import { ReactNode } from 'react'

interface MetricCardProps {
  label: string
  value: string | number
  subtitle?: string
  icon?: ReactNode
  trend?: {
    value: number
    label?: string
  }
  color?: string
}

export function MetricCard({ label, value, subtitle, icon, trend, color = 'brand' }: MetricCardProps) {
  const TrendIcon = trend
    ? trend.value > 0 ? IconTrendingUp : trend.value < 0 ? IconTrendingDown : IconMinus
    : null
  const trendColor = trend
    ? trend.value > 0 ? 'teal' : trend.value < 0 ? 'red' : 'gray'
    : 'gray'

  return (
    <Card>
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start">
          <Text size="sm" c="dimmed" fw={500}>{label}</Text>
          {icon && (
            <ThemeIcon variant="light" color={color} size="lg" radius="md">
              {icon}
            </ThemeIcon>
          )}
        </Group>
        <Text size="2rem" fw={700} lh={1}>{value}</Text>
        {(subtitle || trend) && (
          <Group gap="xs" align="center">
            {trend && TrendIcon && (
              <Group gap={4} align="center">
                <TrendIcon size={14} color={`var(--mantine-color-${trendColor}-6)`} />
                <Text size="xs" c={trendColor} fw={600}>
                  {trend.value > 0 ? '+' : ''}{trend.value}%
                </Text>
              </Group>
            )}
            {subtitle && <Text size="xs" c="dimmed">{subtitle}</Text>}
          </Group>
        )}
      </Stack>
    </Card>
  )
}
